export enum ErrorLevel {
  ERROR = 'ERROR',
  WARNING = 'WARNING'
}
